/**
 * Сервис для работы с сотрудниками
 */

import api from './api';

export interface Employee {
  name: string;
  position: string;
  phone: string;
}

export interface EmployeeSuggestion {
  name: string;
  position: string;
}

export interface EmployeeSuggestions {
  suggestions: EmployeeSuggestion[];
  count: number;
}

class EmployeeService {
  /**
   * Получает предложения имен сотрудников
   */
  async getEmployeeSuggestions(restaurantId?: string): Promise<EmployeeSuggestions> {
    if (!restaurantId) {
      return { suggestions: [], count: 0 };
    }
    return await api.get(`/suggest/employees?restaurant_id=${restaurantId}`);
  }

  /**
   * Получает данные сотрудника по имени
   */
  async getEmployeeByName(name: string, restaurantId?: string): Promise<Employee> {
    const params = restaurantId ? `?restaurant_id=${restaurantId}` : '';
    return await api.get(`/suggest/employee/${encodeURIComponent(name)}${params}`);
  }
}

export default new EmployeeService();